export const term = {
  data() {
    return {
      showTermDialog: false,
      term: ''
    }
  },
  methods: {
    showTerm(term) {
      this.term = term
      this.showTermDialog = true
    }
  }
}
